export const formatTimer = (seconds: number) => {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60

  return `${mins}:${secs < 10 ? '0' : ''}${secs}`
}
